import { Component, OnInit } from '@angular/core';

@Component({
  template: `<h1>Access Denied</h1><p>You are not authorized to access the requested resource.</p>`
})
export class UnauthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
